var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonGenericV2',{staticClass:"e4s-button--150",class:_vm.getCss,attrs:{"text":_vm.getEnterButtonText,"disabled":_vm.isEnterButtonDisabled},on:{"click":_vm.goToComp}})}
var staticRenderFns = []

export { render, staticRenderFns }